import React, { useEffect } from 'react'

const Home = (props) => {

    useEffect(() => {
      window.scrollTo(0,0);
    }, [])
    
    return (
        <section id="home">
            <div className="home-wrapper common-padding">
                <div className="main-title w-100">
                    <img src={require('../assets/profile.jpg')} alt="pro" className="profile-img" />
                    Karan Das
                    <span className="fa-stack fa-sm h4 mt-3 ml-3">
                    <i className="fa fa-certificate text-primary fa-stack-2x"></i>
                    <i className="fa fa-check text-light fa-stack-1x"></i>
                  </span>
                </div>
                <div className="profession">Frontend Developer</div>
                <hr className="pt-1 common-divider rounded-pill mb-2 ml-0 w-50" />

                <div className="contact-details w-100">

                    <div className="contact-item">
                        <i className="fa fa-github fa-fw mr-2"></i>
                        <a href="https://github.com/karandas777">
                            karandas777
                        </a>
                    </div>

                    <div className="contact-item">
                        <i className="fa fa-phone fa-fw mr-2"></i>
                        +91 8828492119.
                    </div>

                    <div className="contact-item">
                        <i className="fa fa-envelope fa-fw mr-2"></i>
                        <a href="mailto:karandas.21.08.98@gmail.com">
                            karandas.21.08.98@gmail.com
                        </a>
                    </div>

                    <div className="contact-item">
                        <i className="fa fa-map-marker fa-fw mr-2"></i>
                        Mumbai, India - 401105.
                    </div>
                </div>

                <div className="social-links text-right w-100">
                    <a
                        className="text-dark text-decoration-none socio"
                        href="https://www.facebook.com/karan.das.7771"
                    >
                        <i className="fa fa-facebook-square"></i>
                    </a>
                    <a
                        className="text-dark text-decoration-none socio"
                        href="https://www.instagram.com/karandas777"
                    >
                        <i className="fa fa-instagram"></i>
                    </a>
                    <a
                        className="text-dark text-decoration-none socio"
                        href="https://twitter.com/karandas_777"
                    >
                        <i className="fa fa-twitter-square"></i>
                    </a>
                </div>
            </div>
            <div className="navi-wrapper">
                <button className="navi-btn anim" onClick={()=>props.setActive("about")} >
                    <i className='fa fa-arrow-down'></i>
                </button>
            </div>
        </section>
    )
}

export default Home